import {
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
  signal,
  effect,
} from "@angular/core";
import { combineLatest, Subject } from "rxjs";
import { DataService } from "../data.service";
import { HttpClient } from "@angular/common/http";
import { takeUntil, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import "lodash";
import { ToastrService } from "ngx-toastr";
declare var _: any;
import { db, dbSwitching$ } from "src/app/db.service";
import { SnapshotService } from "src/app/snapshot.service";
import { MatTableDataSource } from "@angular/material/table";
import { ChartConfiguration, ChartData } from "chart.js";
import { BaseChartDirective } from "ng2-charts";
import { BankService } from "../bank/bank.service";
import { SellsService } from "../sells/sells.service";
import { StockService } from "../stock/stock.service";
import { valueChange } from "../shared/fade.animation";
import { SyncService } from "../sync.service";
import { PusherService } from "../pusher.service";
import { CustomersService } from "../customers/customers.service";
import { UntypedFormControl } from "@angular/forms";
import moment from "moment";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
  animations: [valueChange],
})
export class DashboardComponent implements OnInit, OnDestroy {
  _dataService = inject(DataService);
  _authService = inject(AuthService);
  _bankService = inject(BankService);
  _sellsService = inject(SellsService);
  _stockService = inject(StockService);
  _snapshotService = inject(SnapshotService);
  _syncService = inject(SyncService);
  _customersService = inject(CustomersService);
  _pusher = inject(PusherService);
  _router = inject(Router);
  ngZone = inject(NgZone);
  toastr = inject(ToastrService);
  http = inject(HttpClient);
  dialog = inject(MatDialog);

  constructor() {
    effect(
      () => {
        if (this._bankService.selectedCashboxId()) {
          this.selectedCashboxName = signal(
            this._dataService
              .cashBox()
              .find((c) => c.id == this._bankService.selectedCashboxId())
              ?.name || "Kassa"
          );
          this._bankService._selectedCashboxId$.next(
            this._bankService.selectedCashboxId()
          );
        }
        if (this._stockService.selectedStockGroupId()) {
          this.selectedStockGroupName = signal(
            this._dataService
              .stockGroups()
              .find((c) => c.id == this._stockService.selectedStockGroupId())
              ?.name || "Anbar"
          );
          this._stockService._selectedStockGroupId$.next(
            this._stockService.selectedStockGroupId()
          );
        }
        if (this._dataService.dbChanged()) {
          this.changeDBNavButtons();
          
          // Clear current data to prevent showing stale values
          this.dataLoading = true;
          this.resetDashboardData();
          
          // Wait for database switch to complete, then reload dashboard data
          const currentlySwitching = dbSwitching$.getValue();
          
          if (currentlySwitching) {
            // Database switch is in progress, wait for it to complete
            const subscription = dbSwitching$.subscribe(async (switching) => {
              if (!switching) {
                subscription.unsubscribe();
                
                // Small delay to ensure database is fully ready
                await new Promise(resolve => setTimeout(resolve, 150));
                
                // Reload dashboard data in NgZone
                this.ngZone.run(async () => {
                  this.loadDashboardDataFromStorage();
                  await this.getData();
                  await this.setOveralls();
                });
              }
            });
          } else {
            // Database switch already complete, reload immediately
            setTimeout(async () => {
              this.ngZone.run(async () => {
                this.loadDashboardDataFromStorage();
                await this.getData();
                await this.setOveralls();
              });
            }, 150);
          }
        }
      },
      { allowSignalWrites: true }
    );
  }
  istehsal: {}[] = [];
  sellsGrouppedByProducts: {}[];
  dataStream;
  dataLoading;
  private isLoadingData = false; // Guard flag to prevent concurrent getData() calls
  lastTransactions = [];
  bankTotals: any;
  sellsTotals: any = [];
  stockTotals: any = [];
  selectedCashboxName = this._bankService.selectedCashboxId()
    ? signal(
        this._dataService
          .cashBox()
          .find((c) => c.id == this._bankService.selectedCashboxId())?.name
      )
    : signal("Kassa");
  selectedStockGroupName = signal("Anbar");
  debitKredit;
  profit: { sellsTotal; costTotal; administrativXercler; yekun? } = {
    sellsTotal: 0,
    costTotal: 0,
    administrativXercler: 0,
    yekun: 0,
  };
  totalProduction: any = 0;
  outgoingsByCategory: any = [];
  xammalPayments: number = 0;
  xammalIncomes: number = 0;
  otherIncome: number = 0;
  otherExpenses: number = 0;
  sellsIncome: number = 0;
  selectedDatabase: string = this._dataService.database[0].db;
  @ViewChild("card") card: ElementRef;
  @ViewChild("cardsContainer") cardsContainer: ElementRef;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  componentDestroyed$: Subject<boolean> = new Subject();
  public accountsOverall: any;
  accountsOverallTotals: { sells; income; buy; outgoings } =
    this._dataService.getLS("accountsOverallTotals") || {
      sells: 0,
      income: 0,
      buy: 0,
      outgoings: 0,
    };
  displayedColumns: string[] = [
    "date",
    "sells",
    "income",
    "sellsResidue",
    "stock",
    "outgoings",
    "stockResidue",
  ];

  columnDefs = [
    { headerName: "", field: "tType", flex: 1, maxWidth: 80 },
    {
      headerName: "",
      field: "customerName",
      flex: 2,
      cellRenderer: (params) => {
        return params.data.refersTo
          ? `${params.value}<span>R</span>`
          : params.value;
      },
      cellClass: (params) => {
        return params.data.refersTo ? "editedTransaction" : "";
      },
    },
    {
      headerName: "",
      field: "sum",
      flex: 1,
      cellRenderer: (params) => {
        let result;
        const value = Number(params.value); // Convert to number

        result = !isNaN(value)
          ? `${value
              .toFixed(0)
              .toString()
              .replace(
                /\B(?=(\d{3})+(?!\d))/g,
                " "
              )}<span class="manat" style="font-size: 12px!important; margin-left: 3px">₼</span>`
          : "*";
        return result;
      },
    },
    {
      headerName: "",
      field: "date",
      flex: 1,
      minWidth: 90,
      cellRenderer: (params) => {
        return params.value ? params.value.split("-").reverse().join("-") : "";
      },
    },
  ];

  jwtToken = signal(this._dataService.getLS("kapitalToken") || "");

  public lineChartOptions: ChartConfiguration["options"] = {
    responsive: true,
    backgroundColor: "#2665a4",
    scales: {
      x: {},
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    animation: {
      duration: 0,
    },
  };

  public pieChartOptions: ChartConfiguration["options"] = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "left",
      },
    },
    animation: {
      duration: 0,
    },
  };

  public lineChartData: ChartData<"bar"> = this._dataService.getLS(
    "sellsChartData"
  ) || {
    labels: [],
    datasets: [{ data: [] }],
  };

  public pieChartData: ChartData = this._dataService.getLS("pieChartData") || {
    labels: [],
    datasets: [{ data: [], label: "" }],
  };

  navButtons = [];

  async ngOnInit() {
    // Initialize stock group from LS or default if not set in service
    if (!this._stockService.selectedStockGroupId()) {
      const savedGroupId = this._dataService.getLS("selectedStockGroupId");
      const defaultGroup =
        savedGroupId ||
        this._dataService.stockGroups().find((s) => s.type == 1)?.id ||
        1;

      this._stockService.selectedStockGroupId.set(defaultGroup);
      this._stockService._selectedStockGroupId$.next(defaultGroup);

      // Update local signal name
      const groupName =
        this._dataService.stockGroups().find((c) => c.id == defaultGroup)
          ?.name || "Anbar";
      this.selectedStockGroupName.set(groupName);
    }

    // Load initial data from localStorage for current database
    this.loadDashboardDataFromStorage();
    
    this.changeDBNavButtons();
    
    // Load accountsOverall with database-specific key
    const savedAccountsOverall = this._dataService.getLS("accountsOverall");
    this.accountsOverall = savedAccountsOverall
      ? new MatTableDataSource(savedAccountsOverall)
      : new MatTableDataSource();
      
    this.sellsGrouppedByProducts = JSON.parse(
      localStorage.getItem("sellsGrouppedByProducts")
    );

    combineLatest([
      this._dataService.dateChanged,
      this._syncService.newDataSynced,
    ])
      .pipe(
        takeUntil(this.componentDestroyed$),
        debounceTime(300), // Wait 300ms after last emission before processing
        distinctUntilChanged() // Only emit when the combined value actually changes
      )
      .subscribe(async () => {
        // Small delay to ensure IndexedDB is fully updated after sync
        await new Promise(resolve => setTimeout(resolve, 200));
        this.getData();
      });

    this._syncService.newDataSynced
      .pipe(
        takeUntil(this.componentDestroyed$),
        debounceTime(300) // Wait 300ms after last emission
      )
      .subscribe(async () => {
        // Small delay to ensure IndexedDB is fully updated after sync
        await new Promise(resolve => setTimeout(resolve, 200));
        this.setOveralls();
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  /**
   * Reset dashboard data to default values to prevent showing stale data during DB switch
   */
  resetDashboardData(): void {
    this.bankTotals = { in: 0, out: 0, residue: 0, outBalance: 0, inBalance: 0, residueBalance: 0, sells: 0 };
    this.sellsTotals = { sells: 0, returns: 0, residue: 0 };
    this.stockTotals = { in: 0, out: 0, residue: 0, inBalance: 0, outBalance: 0, residueBalance: 0 };
    this.outgoingsByCategory = [];
    this.totalProduction = 0;
    this.profit = { sellsTotal: 0, costTotal: 0, administrativXercler: 0, yekun: 0 };
    this.xammalPayments = 0;
    this.xammalIncomes = 0;
    this.otherIncome = 0;
    this.otherExpenses = 0;
    this.sellsIncome = 0;
    this.lastTransactions = [];
    this.accountsOverallTotals = { sells: 0, income: 0, buy: 0, outgoings: 0 };
    
    // Reset accountsOverall table
    if (this.accountsOverall) {
      this.accountsOverall.data = [];
    }
  }

  /**
   * Load dashboard data from localStorage for the current database
   */
  loadDashboardDataFromStorage(): void {
    this.lastTransactions = this._dataService.getLS("lastTransactions") || [];
    this.bankTotals = this._dataService.getLS("bankTotals") || { in: 0, out: 0, residue: 0, outBalance: 0, inBalance: 0, residueBalance: 0, sells: 0 };
    this.sellsTotals = this._dataService.getLS("sellsTotals") || [];
    this.stockTotals = this._dataService.getLS("stockTotals") || [];
    this.profit = this._dataService.getLS("profit") ?? { sellsTotal: 0, costTotal: 0, administrativXercler: 0, yekun: 0 };
    this.totalProduction = this._dataService.getLS("totalProduction") ?? 0;
    this.outgoingsByCategory = this._dataService.getLS("outgoingsByCategory") || [];
    this.xammalPayments = this._dataService.getLS("xammalPayments") ?? 0;
    this.xammalIncomes = this._dataService.getLS("xammalIncomes") ?? 0;
    this.otherIncome = this._dataService.getLS("otherIncome") ?? 0;
    this.otherExpenses = this._dataService.getLS("otherExpenses") ?? 0;
    this.sellsIncome = this._dataService.getLS("sellsIncome") ?? 0;
    this.accountsOverallTotals = this._dataService.getLS("accountsOverallTotals") || { sells: 0, income: 0, buy: 0, outgoings: 0 };
    
    this.lineChartData = this._dataService.getLS("sellsChartData") || {
      labels: [],
      datasets: [{ data: [] }],
    };
    
    this.pieChartData = this._dataService.getLS("pieChartData") || {
      labels: [],
      datasets: [{ data: [], label: "" }],
    };
    
    // Load accountsOverall table data
    const savedAccountsOverall = this._dataService.getLS("accountsOverall");
    if (this.accountsOverall) {
      this.accountsOverall.data = savedAccountsOverall || [];
    }
  }

  async getData() {
    // Guard: Prevent concurrent executions
    if (this.isLoadingData) {
      console.log('⏭️ getData() already running, skipping duplicate call');
      return;
    }
    
    this.isLoadingData = true;
    this.dataLoading = true;
    
    try {
      // IMPORTANT: Keep showing cached data while calculating
      // Don't reset to 0, let the old values remain visible during calculation
      // Only update when new data is ready

      // Use optimized comprehensive data retrieval
      const comprehensiveData = await this.getComprehensiveDashboardData();

    // Update all dashboard properties from the optimized data
    this.bankTotals = comprehensiveData.bankTotals;
    this._dataService.setLS("bankTotals", this.bankTotals);

    this.sellsTotals = comprehensiveData.sellsTotals;
    this._dataService.setLS("sellsTotals", this.sellsTotals);

    this.stockTotals = comprehensiveData.stockTotals;
    this._dataService.setLS("stockTotals", this.stockTotals);

    this.outgoingsByCategory = comprehensiveData.outgoingsByCategory;
    this._dataService.setLS("outgoingsByCategory", this.outgoingsByCategory);

    this.totalProduction = comprehensiveData.totalProduction;
    this._dataService.setLS("totalProduction", this.totalProduction);

    this.profit = comprehensiveData.profit;
    this._dataService.setLS("profit", this.profit);

    this.xammalPayments = comprehensiveData.xammalPayments;
    this._dataService.setLS("xammalPayments", this.xammalPayments);

    this.xammalIncomes = comprehensiveData.xammalIncomes;
    this._dataService.setLS("xammalIncomes", this.xammalIncomes);

    this.otherIncome = comprehensiveData.otherIncome;
    this._dataService.setLS("otherIncome", this.otherIncome);

    this.otherExpenses = comprehensiveData.otherExpenses;
    this._dataService.setLS("otherExpenses", this.otherExpenses);

    this.sellsIncome = comprehensiveData.sellsIncome;
    this._dataService.setLS("sellsIncome", this.sellsIncome);

    /* PIE CHART */
    let pieLabels = [];
    let pieChartData = [];
    let i = 0;
    for await (const element of this.outgoingsByCategory) {
      // KASSALAR ARASI KOCURMELER XARIC
      if (element.out > 0 && i < 10 && element.bankGroupId != 30) {
        i++;
        pieLabels.push(
          element.name + " - " + (element.percentage.toFixed(1) ?? 0) + "%"
        );
        pieChartData.push(element.out);
      }
    }
    const clone = this._dataService.getLS("pieChartData") || {
      labels: [],
      datasets: [{ data: [], label: "" }],
    };
    clone.labels = pieLabels;
    clone.datasets[0].data = pieChartData;

    if (JSON.stringify(clone) !== JSON.stringify(this.pieChartData)) {
      this.pieChartData = clone;
      this._dataService.setLS("pieChartData", this.pieChartData);
    }
    /* END PIE CHART */

    // console.time("Cust");
    let cust = await this._customersService.getCustomersBalance(true);
    cust.subscribe();
    // console.timeEnd("Cust");

    this.getLastTransactions();

    this.dataLoading = false;

    this.pieChartOptions.animation = {
      duration: 500,
    };
    } catch (error) {
      console.error('Error in getData():', error);
      this.dataLoading = false;
    } finally {
      // Always release the guard flag
      this.isLoadingData = false;
    }
  }

  // Optimized comprehensive dashboard data retrieval
  async getComprehensiveDashboardData() {
    const startDateString =
      this._dataService.startDate.value.format("YYYY-MM-DD");
    const endDateString = this._dataService.endDate.value.format("YYYY-MM-DD");
    const startDateObj = new Date(startDateString);
    const endDateObj = new Date(endDateString);
    const startDateMs = startDateObj.getTime(); // Cache timestamp for faster comparison
    const endDateMs = endDateObj.getTime();

    // Single DB query for all data up to end date - this is the key optimization
    // OPTIMIZATION: Only fetch stock transactions within the selected period
    // We don't need historical stock transactions because we use getMaterialTotalsOptimized() for residue
    const [allBankTx, allSellsTx, allStockTx] =
      await Promise.all([
        db.bank.where("date").belowOrEqual(endDateString).toArray(),
        db.sells.where("date").belowOrEqual(endDateString).toArray(),
        db.stock.where("date").between(startDateString, endDateString, true, true).toArray(),
      ]);

    // Get reference data
    const bankGroupsList: any = this._dataService.bankGroups();
    const bankGroupsMap: any = new Map(
      bankGroupsList.map((bg: any) => [bg.id?.toString(), bg])
    );
    const materialsList: any = this._dataService.materials();
    const materialsMap: any = new Map(materialsList.map((m: any) => [m.id, m]));
    const productsList: any = this._dataService.products();
    const productsMap: any = new Map(productsList.map((p: any) => [p.id, p]));
    const formulaGroupsMap: any = new Map(
      this._dataService.formulaGroups().map((fg: any) => [fg.id, fg])
    );

    // Initialize result object
    const result: any = {
      bankTotals: {
        in: 0,
        out: 0,
        residue: 0,
        outBalance: 0,
        inBalance: 0,
        residueBalance: 0,
        sells: 0,
      },
      sellsTotals: {
        sells: 0,
        returns: 0,
        residue: 0,
      },
      stockTotals: {
        in: 0,
        out: 0,
        residue: 0,
        inBalance: 0,
        outBalance: 0,
        residueBalance: 0,
      },
      outgoingsByCategory: [],
      totalProduction: { totalQuantity: 0, totalPrice: 0 },
      profit: { sellsTotal: 0, costTotal: 0, administrativXercler: 0, yekun: 0 },
      xammalPayments: 0,
      xammalIncomes: 0,
      otherIncome: 0,
      otherExpenses: 0,
      sellsIncome: 0,
    };

    // Separate totals for global calculations (not affected by cashbox filter)
    const globalBankTotals: any = {
      in: 0,
      out: 0,
      sells: 0,
    };

    // Helper function to get product unit cost
    const getProductUnitCostLocal = (productId: any): number => {
      const productDetails: any = productsMap.get(productId);
      if (!productDetails) return 0;

      let baseFormulaCost: number = 0;
      const formulaGroup: any = productDetails.formulaGroupId
        ? formulaGroupsMap.get(productDetails.formulaGroupId)
        : null;

      const formulaCostVal: number = formulaGroup?.cost || 0;

      if (typeof productDetails.weight === "number") {
        baseFormulaCost =
          productDetails.width && productDetails.width !== 0
            ? (formulaCostVal * productDetails.weight) / productDetails.width
            : formulaCostVal * productDetails.weight;
        baseFormulaCost = isNaN(baseFormulaCost) ? 0 : baseFormulaCost;
      }

      const uzlemeCost: number =
        typeof productDetails.uzleme === "number" ? productDetails.uzleme : 0;
      const totalCost: number = baseFormulaCost + uzlemeCost;
      return isNaN(totalCost) ? 0 : totalCost;
    };

    // Process Bank Transactions
    const periodOutgoingsAggregator: any = {};
    const periodIncomesAggregator: any = {};
    const selectedCashboxId = this._bankService.selectedCashboxId();

    // OPTIMIZATION: Use for loop instead of forEach for better performance
    const bankTxLength = allBankTx.length;
    for (let i = 0; i < bankTxLength; i++) {
      const tx = allBankTx[i];
      
      // OPTIMIZATION: Cache date conversion and use timestamp comparison
      const txDateMs = new Date(tx.date).getTime();
      const isInPeriod = txDateMs >= startDateMs && txDateMs <= endDateMs;
      const isBeforePeriod = txDateMs < startDateMs;
      
      // Early skip if not in period and not before period
      if (!isInPeriod && !isBeforePeriod) continue;
      
      const income = Number(tx.income) || 0;
      const outgoings = Number(tx.outgoings) || 0;
      const bankGroupId = tx.bankGroupId;
      
      // OPTIMIZATION: Cache bankGroup lookup
      const bankGroup: any = bankGroupsMap.get(bankGroupId?.toString());

      // Always process global totals (for Gəlir and Satışlar "Alınan")
      // Skip internal transfers for global calculations
      if (bankGroupId !== 30 && isInPeriod) {
        globalBankTotals.in += income;
        globalBankTotals.out += outgoings;
        if (bankGroupId === 0) globalBankTotals.sells += income;
      }

      // Apply cashbox filter for KASSA card only
      const passesCashboxFilter = !selectedCashboxId || tx.cashboxId === selectedCashboxId;
      // Skip internal transfers unless no cashbox selected
      const passesTransferFilter = selectedCashboxId || bankGroupId !== 30;
      
      if (!passesCashboxFilter || !passesTransferFilter) {
        continue;
      }

      if (isInPeriod) {
        result.bankTotals.in += income;
        result.bankTotals.out += outgoings;
        
        if (bankGroup?.includeInBalance) {
          result.bankTotals.outBalance += outgoings;
          result.bankTotals.inBalance += income;
        }
        
        if (bankGroupId === 0) result.bankTotals.sells += income;

        // Aggregate outgoings by category
        if (outgoings > 0 && bankGroupId !== 30) {
          if (!periodOutgoingsAggregator[bankGroupId]) {
            periodOutgoingsAggregator[bankGroupId] = {
              name: bankGroup?.name || `Group ${bankGroupId}`,
              bankGroupId: bankGroupId,
              out: 0,
            };
          }
          periodOutgoingsAggregator[bankGroupId].out += outgoings;
        }

        // Aggregate incomes by category
        if (income > 0) {
          if (!periodIncomesAggregator[bankGroupId]) {
            periodIncomesAggregator[bankGroupId] = {
              name: bankGroup?.name || `Group ${bankGroupId}`,
              bankGroupId: bankGroupId,
              in: 0,
            };
          }
          periodIncomesAggregator[bankGroupId].in += income;
        }
      } else if (isBeforePeriod) {
        result.bankTotals.residue += income - outgoings;
        if (bankGroup?.includeInBalance) {
          result.bankTotals.residueBalance += income - outgoings;
        }
      }
    }

    // Process outgoings by category and calculate percentages
    const outgoingsList: any = Object.values(periodOutgoingsAggregator).sort(
      (a: any, b: any) => b.out - a.out
    );
    const totalOut: number = outgoingsList.reduce(
      (sum: number, obj: any) => (obj.bankGroupId != 30 ? sum + obj.out : sum),
      0
    );
    result.outgoingsByCategory = outgoingsList.map((obj: any) => ({
      ...obj,
      percentage: totalOut > 0 ? (obj.out / totalOut) * 100 : 0,
    }));

    // Process incomes by category
    const incomesList: any = Object.values(periodIncomesAggregator);

    // Calculate xammalPayments (outgoing payments for "Xammal")
    const xammalOutgoing = result.outgoingsByCategory.find(
      (o: any) => o.name === "Xammal"
    );
    result.xammalPayments = xammalOutgoing?.out ?? 0;

    // Calculate sellsIncome (income from bankGroupId === 0, which is "Satış")
    const sellsIncomeItem = incomesList.find((i: any) => i.bankGroupId === 0);
    result.sellsIncome = sellsIncomeItem?.in ?? 0;

    // Calculate xammalIncomes (incomes from bankGroupCategory == 2)
    const adminIncomeBankGroupIds: string[] = bankGroupsList
      .filter((bg: any) => bg.bankGroupCategory == 2)
      .map((bg: any) => bg.id?.toString());
    result.xammalIncomes = incomesList
      .filter((item: any) => adminIncomeBankGroupIds.includes(item.bankGroupId?.toString()))
      .reduce((sum: number, item: any) => sum + item.in, 0);

    // Calculate otherIncome (incomes NOT from Satış, Köçürmə, or admin categories)
    const otherIncomeIds: string[] = bankGroupsList
      .filter((bg: any) => bg.bankGroupCategory !== 2)
      .map((bg: any) => bg.id?.toString());
    result.otherIncome = incomesList
      .filter(
        (item: any) =>
          item.name !== "Satış" &&
          item.name !== "Köçürmə" &&
          otherIncomeIds.includes(item.bankGroupId?.toString())
      )
      .reduce((sum: number, item: any) => sum + item.in, 0);

    // Get selected stock group ID for filtering
    const selectedStockGroupId = this._stockService.selectedStockGroupId();

    // Process Sells Transactions - OPTIMIZED with for loop
    const sellsTxLength = allSellsTx.length;
    for (let i = 0; i < sellsTxLength; i++) {
      const tx = allSellsTx[i];
      const txDateMs = new Date(tx.date).getTime();
      const isInPeriod = txDateMs >= startDateMs && txDateMs <= endDateMs;
      
      // Early skip if after period
      if (txDateMs > endDateMs) continue;
      
      const quantity = Number(tx.quantity) || 0;
      const price = Number(tx.price) || 0;
      const transactionValue = quantity * price;

      // Calculate Cost Value for Stock Adjustment (COGS)
      // We need to subtract the COST of the sold items from the stock value, not the SALE price
      const material = materialsMap.get(tx.materialId);
      const costPrice = material?.price || 0;
      const costValue = quantity * costPrice;

      // Apply stock group filter for stock totals adjustment
      const matchesStockGroup = !selectedStockGroupId || tx.stockGroupId === selectedStockGroupId;

      if (isInPeriod) {
        if (quantity > 0) result.sellsTotals.sells += transactionValue;
        else if (quantity < 0) result.sellsTotals.returns += transactionValue;

        // Adjust Stock Totals for Sales (COGS)
        if (matchesStockGroup) {
          // Sales (positive quantity) reduce stock value
          if (quantity > 0) {
            result.stockTotals.out -= costValue; // Out is negative, so we subtract positive cost
            if (tx.customerId) result.stockTotals.outBalance -= costValue;
          }
          // Returns (negative quantity) increase stock value (treated as negative out or positive in?)
          // Usually returns are "Stock In" effectively, but here we treat them as reversing the sale
          else if (quantity < 0) {
             result.stockTotals.out -= costValue; // costValue is negative, so this adds to Out (making it less negative)
             if (tx.customerId) result.stockTotals.outBalance -= costValue;
          }
        }

      } else {
        result.sellsTotals.residue += transactionValue;
        // Stock residue adjustment removed as it is overwritten by actualEndValue
      }
    }

    // Process Stock Transactions - OPTIMIZED with for loop
    // selectedStockGroupId is already declared above
    const stockTxLength = allStockTx.length;
    
    for (let i = 0; i < stockTxLength; i++) {
      const tx = allStockTx[i];
      
      // Apply stock group filter if needed
      if (selectedStockGroupId && tx.stockGroupId !== selectedStockGroupId) {
        continue;
      }

      const txDateMs = new Date(tx.date).getTime();
      const isInPeriod = txDateMs >= startDateMs && txDateMs <= endDateMs;
      
      // Early skip if after period
      if (txDateMs > endDateMs) continue;
      
      const quantity = Number(tx.quantity) || 0;
      const price = Number(tx.price) || 0;
      const transactionValue = quantity * price;

      if (isInPeriod) {
        if (quantity > 0) {
          result.stockTotals.in += transactionValue;
          if (tx.customerId) result.stockTotals.inBalance += transactionValue;
        }
        // For negative quantities, the transactionValue is already negative
        if (quantity < 0) {
          result.stockTotals.out += transactionValue; // This will be negative
          if (tx.customerId) result.stockTotals.outBalance += transactionValue;
        }
      }
      // Residue calculation removed as it is overwritten by actualEndValue
    }

    // Initial Balance calculation removed as it is handled by getMaterialTotalsOptimized
    // and overwritten in result.stockTotals.residue assignment below

    // Calculate Total Production (materials used) - OPTIMIZED
    // Filter materials used in production in the period
    const materialUsageMap: any = {};
    const stockTxLen = allStockTx.length;
    
    for (let i = 0; i < stockTxLen; i++) {
      const tx = allStockTx[i];
      if (tx.tType !== "Production") continue;
      
      const txDateMs = new Date(tx.date).getTime();
      if (txDateMs < startDateMs || txDateMs > endDateMs) continue;
      
      const materialId = tx.materialId;
      if (!materialUsageMap[materialId]) {
        materialUsageMap[materialId] = {
          materialId: materialId,
          sum: 0,
        };
      }
      // Don't use Math.abs - keep the negative quantity
      materialUsageMap[materialId].sum += Number(tx.quantity) || 0;
    }

    // Get material totals to determine current unit prices AND total stock value
    // Using optimized snapshot-based query (no auto-migration, uses deltas created by components)
    // Pass selectedStockGroupId to get correct totals for the selected group
    const mTotals = await this._stockService.getMaterialTotalsOptimized(endDateString, selectedStockGroupId);

    // Calculate actual total value from service (Source of Truth)
    // This ensures Dashboard matches Stock and Material components exactly
    // IMPORTANT: Use Math.max(0, ...) to only include positive values (same as Materials Component)
    // Negative stock values don't make business sense for inventory valuation
    const actualEndValue = mTotals.reduce((sum, m) => sum + Math.max(0, m.totalPrice || 0), 0);

    // Force the residue to align with the actual end value
    // Formula: Residue + In + Out = EndValue
    // Therefore: Residue = EndValue - In - Out
    // Note: Out is negative, so we subtract it (double negative = positive)
    result.stockTotals.residue = actualEndValue - result.stockTotals.in - result.stockTotals.out;

    let totalMaterialQuantity = 0;
    let totalMaterialPrice = 0;

    Object.values(materialUsageMap).forEach((m: any) => {
      const material = mTotals.find((mm: any) => mm.materialId == m.materialId);
      if (material) {
        m.unitPrice = material.unitPrice;
        m.totalPrice = m.sum * m.unitPrice;

        totalMaterialQuantity += m.sum;
        totalMaterialPrice += m.totalPrice;
      }
    });

    result.totalProduction = {
      totalQuantity: totalMaterialQuantity,
      totalPrice: totalMaterialPrice,
    };

    // Calculate Profit - OPTIMIZED: reuse already filtered data
    const periodProfitCalcItems: any = {};
    
    // Process sells for profit (already have the data from earlier)
    for (let i = 0; i < sellsTxLength; i++) {
      const sell = allSellsTx[i];
      const txDateMs = new Date(sell.date).getTime();
      
      if (txDateMs < startDateMs || txDateMs > endDateMs) continue;
      
      const { productId, materialId, quantity, price } = sell;
      const numQty = Number(quantity) || 0;
      const numPrice = Number(price) || 0;
      let itemCostVal = 0;
      let id = productId || materialId;

      if (productId) itemCostVal = getProductUnitCostLocal(productId);
      else if (materialId)
        itemCostVal = materialsMap.get(materialId)?.price || 0;

      if (id) {
        if (!periodProfitCalcItems[id]) {
          periodProfitCalcItems[id] = {
            sellsValue: 0,
            costValue: 0,
          };
        }
        periodProfitCalcItems[id].sellsValue += numQty * numPrice;
        periodProfitCalcItems[id].costValue += numQty * itemCostVal;
      }
    }

    Object.values(periodProfitCalcItems).forEach((item: any) => {
      result.profit.sellsTotal += item.sellsValue;
      result.profit.costTotal += item.costValue;
    });

    // Calculate administrative expenses and other expenses - OPTIMIZED for loop
    const adminExpBankGroupIds = bankGroupsList
      .filter((bg: any) => bg.bankGroupCategory == 2)
      .map((bg: any) => bg.id?.toString());

    // Calculate other expenses (bank groups NOT in categories 1, 2, or 4, and NOT "Köçürmə")
    const otherExpBankGroupIds: string[] = bankGroupsList
      .filter(
        (bg: any) =>
          bg.bankGroupCategory !== 1 &&
          bg.bankGroupCategory !== 2 &&
          bg.bankGroupCategory !== 4 &&
          bg.name !== "Köçürmə"
      )
      .map((bg: any) => bg.id);

    // Process bank transactions for admin and other expenses
    for (let i = 0; i < bankTxLength; i++) {
      const tx = allBankTx[i];
      const txDateMs = new Date(tx.date).getTime();
      
      if (txDateMs < startDateMs || txDateMs > endDateMs) continue;
      
      const bankGroupIdStr = tx.bankGroupId?.toString();
      if (bankGroupIdStr && adminExpBankGroupIds.includes(bankGroupIdStr)) {
        result.profit.administrativXercler += Number(tx.outgoings) || 0;
      }
      if (otherExpBankGroupIds.includes(tx.bankGroupId)) {
        result.otherExpenses += Number(tx.outgoings) || 0;
      }
    }

    // Calculate Yekun (Gəlir) using the same formula as profit component
    // Formula: sellsIncome - xammalPayments + xammalIncomes - administrativXercler - otherExpenses + otherIncome
    result.profit.yekun = 
      result.sellsIncome -
      result.xammalPayments +
      result.xammalIncomes -
      result.profit.administrativXercler -
      result.otherExpenses +
      result.otherIncome;

    // Also store the global "Alınan" (sells income) for the Satışlar card
    result.bankTotals.globalSells = globalBankTotals.sells;

    // Format all numeric values to 2 decimal places
    const formatRecursive = (obj: any) => {
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === "number") {
          obj[key] = parseFloat(obj[key].toFixed(2));
        } else if (Array.isArray(obj[key])) {
          obj[key].forEach((el: any) => {
            if (typeof el === "object" && el !== null) formatRecursive(el);
          });
        } else if (typeof obj[key] === "object" && obj[key] !== null) {
          formatRecursive(obj[key]);
        }
      });
    };

    formatRecursive(result);
    return result;
  }

  async getOveralls() {
    const currentDate = new Date();
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 11);
    twelveMonthsAgo.setDate(1);
    
    const twelveMonthsAgoStr = moment(twelveMonthsAgo).format('YYYY-MM-DD');
    const currentDateStr = moment(currentDate).add(1, 'day').format('YYYY-MM-DD');

    // 1. Get optimized data for last 12 months
    const stocksDX = await db.stock.where('date').between(twelveMonthsAgoStr, currentDateStr, true, true).toArray();
    const sellsDX = await db.sells.where('date').between(twelveMonthsAgoStr, currentDateStr, true, true).toArray();
    const bankDX = await db.bank.where('date').between(twelveMonthsAgoStr, currentDateStr, true, true).toArray();

    // 2. Get Current Stock Value (The Anchor) using the optimized service
    const currentMaterials = await this._stockService.getMaterialTotalsOptimized(currentDateStr);
    // Use Math.max(0, ...) to only include positive values (consistent with other calculations)
    const currentTotalValue = currentMaterials.reduce((sum, m) => sum + Math.max(0, m.totalPrice || 0), 0);

    // 3. Calculate Monthly Net Changes (In - Out) for the fetched period
    const monthlyChanges = {};
    const materialsMap = new Map(this._dataService.materials().map(m => [m.id, m]));

    // Track total material purchases (positive quantities only) for accountsOverallTotals.buy
    const materialPurchases = {};
    
    // Process Stocks (In and Out)
    stocksDX.forEach(stock => {
      const date = new Date(stock.date);
      const monthKey = `${date.getFullYear()}-${date.getMonth() + 1}`;
      if (!monthlyChanges[monthKey]) monthlyChanges[monthKey] = 0;
      
      // Add value (quantity * price). Note: quantity is negative for out/production
      monthlyChanges[monthKey] += stock.quantity * stock.price;
      
      // Track purchases separately (only positive quantities = material purchases)
      if (stock.quantity > 0) {
        if (!materialPurchases[monthKey]) materialPurchases[monthKey] = 0;
        materialPurchases[monthKey] += stock.quantity * stock.price;
      }
    });

    // Process Sells (Out) - Sells reduce stock value
    sellsDX.forEach(sell => {
      const date = new Date(sell.date);
      const monthKey = `${date.getFullYear()}-${date.getMonth() + 1}`;
      if (!monthlyChanges[monthKey]) monthlyChanges[monthKey] = 0;
      
      const material:any = materialsMap.get(sell.materialId);
      if (material) {
         // Sells reduce stock, so we subtract (quantity * cost price)
         const qty = Math.abs(sell.quantity);
         monthlyChanges[monthKey] -= qty * material?.price;
      }
    });

    // 4. Calculate Monthly Balances working backwards
    const monthlyBalances = {};
    let runningValue = currentTotalValue;
    
    // Generate list of months in reverse order (from current back to 12 months ago)
    const monthsReverse = [];
    let d = new Date(currentDate);
    d.setDate(1); // Start from 1st of current month
    
    const stopDate = new Date(twelveMonthsAgo);
    
    while (d >= stopDate) {
      monthsReverse.push(`${d.getFullYear()}-${d.getMonth() + 1}`);
      d.setMonth(d.getMonth() - 1);
    }

    // Calculate balances
    monthsReverse.forEach((monthKey, index) => {
      // The value at the END of this month is the runningValue
      monthlyBalances[monthKey] = runningValue;
      
      // For the next iteration (previous month), subtract the net change of this month
      // Balance[Prev] = Balance[Curr] - Change[Curr]
      const change = monthlyChanges[monthKey] || 0;
      runningValue -= change;
    });

    // 5. Original Logic for other metrics
    const sells = sellsDX.reduce((accumulator, stock) => {
      const date = new Date(stock.date);
      const monthKey = `${date.getFullYear()}-${date.getMonth() + 1}`;

      if (date >= twelveMonthsAgo && date <= currentDate) {
        if (!accumulator[monthKey]) {
          accumulator[monthKey] = 0;
        }

        accumulator[monthKey] += stock.quantity * stock.price;
      }

      return accumulator;
    }, {});

    const bankIn = bankDX.reduce((accumulator, bank) => {
      const date = new Date(bank.date);
      const monthKey = `${date.getFullYear()}-${date.getMonth() + 1}`;

      if (date >= twelveMonthsAgo && date <= currentDate) {
        if (!accumulator[monthKey]) {
          accumulator[monthKey] = 0;
        }

        accumulator[monthKey] += bank.bankGroupId == 0 ? bank.income : 0;
      }

      return accumulator;
    }, {});

    const bankOut = bankDX.reduce((accumulator, bank) => {
      const date = new Date(bank.date);
      const monthKey = `${date.getFullYear()}-${date.getMonth() + 1}`;

      if (date >= twelveMonthsAgo && date <= currentDate) {
        if (!accumulator[monthKey]) {
          accumulator[monthKey] = 0;
        }

        accumulator[monthKey] += bank.bankGroupId == 1 ? bank.outgoings : 0;
      }

      return accumulator;
    }, {});

    // Note: stockOut logic in original code was identical to bankOut (copy-paste error in original?)
    // "const stockOut = bankDX.reduce..." -> it was using bankDX and bankGroupId == 1
    // I will preserve it as is to avoid breaking existing behavior, but it looks suspicious.
    const stockOut = bankDX.reduce((accumulator, bank) => {
      const date = new Date(bank.date);
      const monthKey = `${date.getFullYear()}-${date.getMonth() + 1}`;

      if (date >= twelveMonthsAgo && date <= currentDate) {
        if (!accumulator[monthKey]) {
          accumulator[monthKey] = 0;
        }

        accumulator[monthKey] += bank.bankGroupId == 1 ? bank.outgoings : 0;
      }

      return accumulator;
    }, {});

    let combinedObject = Object.assign(
      {},
      monthlyBalances, // Use our new balances
      sells,
      bankIn,
      bankOut,
      stockOut,
      materialPurchases // Add material purchases
    );

    const result = Object.keys(combinedObject)
      .map((monthKey) => {
        const [year, month] = monthKey.split("-");

        return {
          yr: parseInt(year),
          mon: parseInt(month),
          sells: sells[monthKey] || 0,
          income: bankIn[monthKey],
          outgoings: bankOut[monthKey],
          stock: materialPurchases[monthKey] || 0, // Material purchases for this month (Xammal Alışı)
          stockOut: stockOut[monthKey],
        };
      })
      .sort((a, b) => {
        if (a.yr !== b.yr) {
          return b.yr - a.yr;
        }
        return b.mon - a.mon;
      });

    this.accountsOverallTotals = { sells: 0, income: 0, buy: 0, outgoings: 0 };
    result.forEach((r) => {
      this.accountsOverallTotals.sells += r.sells || 0;
      this.accountsOverallTotals.income += r.income || 0;
      this.accountsOverallTotals.outgoings += r.outgoings || 0;
    });
    
    // Calculate total material purchases (sum of all purchases across all months)
    // This represents "Xammal Alışı" - total value of materials bought during the period
    this.accountsOverallTotals.buy = Object.values(materialPurchases).reduce(
      (sum: number, val: number) => sum + val, 
      0
    );
    
    this._dataService.setLS(
      "accountsOverallTotals",
      this.accountsOverallTotals
    );
    return result;
  }

  async setOveralls() {
    // OVERALLS TABLE
    // console.time("getOveralls");
    this.accountsOverall.data = await this.getOveralls();
    // console.timeEnd("getOveralls");

    /* LINE CHART */
    let labels = [],
      chartData = [];

    for (let i = 10; i >= 0; i--) {
      if (
        this.accountsOverall.data[i] &&
        this.accountsOverall.data[i].sells > 0
      ) {
        labels.push(
          this.accountsOverall.data[i].mon +
            "/" +
            this.accountsOverall.data[i].yr
        );
        chartData.push(this.accountsOverall.data[i].sells);
      }
    }

    this.lineChartData.datasets[0] = {
      data: chartData,
    };
    this.lineChartData.labels = labels;
    this.chart.update();
    this._dataService.setLS("sellsChartData", this.lineChartData);

    // Save accountsOverall with database-specific key
    this._dataService.setLS("accountsOverall", this.accountsOverall.data);
    
    this.dataLoading = false;
  }

  async getLastTransactions() {
    this.lastTransactions = await db.transactions.reverse().limit(25).toArray();

    this.lastTransactions.map((item) => {
      item.customerName =
        _.find(this._dataService.customers(), {
          id: item.customerId,
        })?.name || "*";
      item.tType = this._dataService.getTransactionType(item.type, item);
    });
    this._dataService.setLS("lastTransactions", this.lastTransactions);
  }

  addToDo(toDoText) {
    if (toDoText) {
      this._dataService.todos.set([
        ...this._dataService.todos(),
        {
          todo: toDoText,
          id: 0,
          userId: this._authService.loggedInUserValue.id,
        },
      ]);
      localStorage.setItem("todos", JSON.stringify(this._dataService.todos()));
      this.http
        .post(this._dataService.dbBase + `api.php/records/todos/`, {
          todo: toDoText,
          userId: this._authService.loggedInUserValue.id,
          id: null,
        })
        .subscribe((r) => {
          this.toastr.success("", "Əlavə edildi!", {
            toastClass: "ngx-toastr customToast",
            progressBar: true,
            timeOut: 2500,
            progressAnimation: "increasing",
          });
          const item = this._dataService.todos().find((item) => item.id === 0);
          item.id = r;
        });
    }
  }

  doneToDo(todoId) {
    let todo = this._dataService.todos().find((todo) => todo.id == todoId);
    todo.status = 1;

    this.http
      .put(this._dataService.dbBase + `api.php/records/todos/${todoId}`, {
        status: 1,
      })
      .subscribe(() =>
        this.toastr.success("", "Uğurlu!", {
          toastClass: "ngx-toastr customToast",
          progressBar: true,
          timeOut: 2500,
          progressAnimation: "increasing",
        })
      );
  }

  removeToDo(todoId) {
    const index = this._dataService
      .todos()
      .findIndex((item) => item.id === todoId);
    if (index > -1) {
      this._dataService.todos().splice(index, 1);
    }
    this.http
      .delete(this._dataService.dbBase + `api.php/records/todos/${todoId}`)
      .subscribe(() =>
        this.toastr.success("", "Silindi!", {
          toastClass: "ngx-toastr customToast",
          progressBar: true,
          timeOut: 2500,
          progressAnimation: "increasing",
        })
      );
  }

  getNextCashboxId(): number {
    const currentIndex = this._dataService
      .cashBox()
      .findIndex(
        (cashbox) => cashbox.id === this._bankService.selectedCashboxId()
      );
    const nextIndex = (currentIndex + 1) % this._dataService.cashBox().length;
    if (currentIndex == this._dataService.cashBox().length - 1) {
      this._bankService.selectedCashboxId.set(0);
      this._bankService._selectedCashboxId$.next(0);
      this.selectedCashboxName.set("Kassa");
    } else {
      this._bankService.selectedCashboxId.set(
        this._dataService.cashBox()[nextIndex].id
      );
    }

    // Recalculate data immediately after changing cashbox
    this.getData();

    return this._bankService.selectedCashboxId();
  }

  getNextStockGroupId(): number {
    const currentIndex = this._dataService
      .stockGroups()
      .findIndex(
        (cashbox) => cashbox.id === this._stockService.selectedStockGroupId()
      );
    const nextIndex =
      (currentIndex + 1) % this._dataService.stockGroups().length;
    if (currentIndex == this._dataService.stockGroups().length - 1) {
      this._stockService.selectedStockGroupId.set(0);
      this._stockService._selectedStockGroupId$.next(0);
      this.selectedStockGroupName.set("Anbar");
    } else {
      this._stockService.selectedStockGroupId.set(
        this._dataService.stockGroups()[nextIndex].id
      );
    }

    // Recalculate data immediately after changing stock group
    this.getData();

    return this._bankService.selectedCashboxId();
  }

  async changeDB(database?) {
    const dbName = database?.db ?? database;
    if (this._dataService.dbTable !== dbName) {
      this._dataService.dbChanged.set(dbName);
      this._syncService.showSyncLine = true;
      this.dataLoading = true;
      this._dataService.dbTable = dbName;
      localStorage.setItem("dbTable", JSON.stringify(dbName)); // Ensure localStorage is updated

      // Optionally, switch Dexie database instance if needed
      // await switchDatabase(dbName);

      if (navigator.onLine) {
        await this._syncService.syncDB();
        this._syncService.getSettings(); // Not awaited, as it's forkJoin/subscribe
      } else {
        await this._syncService.offlineSettings();
      }

      this.changeDBNavButtons();

      await this.getData();
      await this.setOveralls();
      await this._syncService.cleanupOrphanedRecords();

      this.dataLoading = false;
    }
  }

  changeDBNavButtons() {
    this.navButtons = [];
    const selectedDB = this._dataService.database.find(
      (db) => db.db === this._dataService.dbTable
    );

    if (selectedDB) {
      this.navButtons.push({
        name: selectedDB.name,
        icon: "hard_drive",
        function: () => this.changeDB(selectedDB),
      });
    }

    this._dataService.database.forEach((db) => {
      if (db !== selectedDB) {
        this.navButtons.push({
          name: db.name,
          icon: "switch_left",
          function: () => this.changeDB(db),
        });
      }
    });
  }

  changeSelectedDate(row) {
    if (
      row &&
      typeof row.mon === "number" &&
      typeof row.yr === "number" &&
      row.mon >= 1 &&
      row.mon <= 12 &&
      row.yr > 1900
    ) {
      // moment months are 0-based
      const startDate = moment({ year: row.yr, month: row.mon - 1, day: 1 });
      const endDate = startDate.clone().endOf("month");

      this._dataService.startDate = new UntypedFormControl(startDate);
      this._dataService.setLS("startDate", { value: startDate.format() });

      this._dataService.endDate = new UntypedFormControl(endDate);
      this._dataService.setLS("endDate", { value: endDate.format() });

      this._dataService.dateChanged.next(startDate.toString());
      this._dataService.setActiveClassOnDates();
    }
  }
}
